import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { JobDataComponent} from './job-data.component'
const routes: Routes = [
  {
    path: '',
    component: JobDataComponent
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class JobDataRoutingModule { }
